
import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseURL } from "../common/baseURL";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; 
import { CiLogout } from "react-icons/ci";

function Login() {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // For page redirection

  useEffect(() => {
    
    const token = localStorage.getItem("authTokenforEIF");
    const expiry = localStorage.getItem("expiryTime");

    if (token && expiry) {
      const now = new Date().getTime();
      if (now < expiry) {
        navigate("/allfolders"); 
      } else {
        logout(); 
      }
    }
  }, [navigate]);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = (password) =>
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$/.test(password);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");

    if (!validateEmail(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }
    if (!validatePassword(password)) {
      setMessage(
        "Enter a valid password"
      );
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/login`, {
        email,
        password,
      });

      if (response.data.success) {
        setMessage("Login successful!");

      
        const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000; 
        localStorage.setItem("authTokenforEIF", response.data.token);
        localStorage.setItem("expiryTime", expiryTime);

        navigate("/allfolders"); 
      } else {
        setMessage(response.data.message || "Login failed.");
      }
    } catch (error) {
      setMessage(error.response?.data?.message || "An error occurred.");
    }
    setLoading(false);
  };

  const logout = () => {
    localStorage.removeItem("authTokenforEIF");
    localStorage.removeItem("expiryTime");
    navigate("/");
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <form id="uploadForm" onSubmit={handleSubmit} style={styles.form}>
          {/* <h4 style={{ background: 'conic-gradient(from 65deg, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))',color:'white',padding:10,width:'90%',fontWeight:'bold'}}>Login to Digital Signage System Dashboard</h4> */}
          
          <h4 style={{ 
    background: 'conic-gradient(from 65deg, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))', 
    color: 'white', 
    padding: 10, 
    width: '90%', 
    fontWeight: 'bold', 
    whiteSpace: 'normal', 
    wordWrap: 'break-word', 
    textAlign: 'center'
}}>
    Login to Digital Signage System <br /> Dashboard
</h4>


          <input
            type="text"
            value={email}
            required
            placeholder="Enter email "
            onChange={(e) => setEmail(e.target.value)}
            style={styles.fileInput}
          />

         
          <div style={styles.passwordContainer}>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              required
              placeholder="Enter password "
              onChange={(e) => setPassword(e.target.value)}
              style={{...styles.fileInput,width:'90%'}}
            />
            <span
              style={styles.eyeIcon}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

    
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>

      
          <div id="message" style={styles.message}>
            {message}
          </div>
        </form>
      </div>
    </div>
  );
}


const styles = {
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    background: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    width: "96%",
    maxWidth: "350px",
    justifyContent: "center",
    borderRadius: "8px",
  },
  fileInput: {
    marginBottom: "10px",
    padding: "8px",
    width: "90%",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  passwordContainer: {
    position: "relative",
    width: "100%",
    //maxWidth: "300px",
  },
  eyeIcon: {
    position: "absolute",
    right: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#555",
  },
  button: {
    padding: "10px 20px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    color: "white",
    cursor: "pointer",
    background: "linear-gradient(to right, #191c51, #2092d0)",
    width:'60%'
  },
  message: {
    marginTop: "15px",
    color: "black",
  },
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Arial, sans-serif",
    background: "linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
  },
};

export default Login;
